// extracted by mini-css-extract-plugin
export default {"card":"confirm-peer-ratings-modal_card__yq0Sd","cards":"confirm-peer-ratings-modal_cards__VA-38"};